import script from "./PickableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PickableItem.vue?vue&type=script&setup=true&lang=js"

import "./PickableItem.vue?vue&type=style&index=0&id=6b93294c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b93294c"]])

export default __exports__